var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 122,
    viewBox: "0 0 1440 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-32 60L8.86333 63.3C49.8033 66.7 131.53 73.3 213.333 74.7C295.137 76 376.863 72 458.667 72.2C540.47 72.3 622.197 76.7 704 76.8C785.803 77 867.53 73 949.333 70.5C1031.14 68 1112.86 67 1194.67 75.8C1276.47 84.7 1358.2 103.3 1399.14 112.7L1440 122V0H1399.14C1358.2 0 1276.47 0 1194.67 0C1112.86 0 1031.14 0 949.333 0C867.53 0 785.803 0 704 0C622.197 0 540.47 0 458.667 0C376.863 0 295.137 0 213.333 0C131.53 0 49.8033 0 8.86333 0H-32V60Z",
    fill: "#E7EDFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIntegration);
export default __webpack_public_path__ + "static/media/articleIntegration.6c32edf3ae882ddec6795db043db47c6.svg";
export { ForwardRef as ReactComponent };